import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { QuestionsService } from '../../routes/questions/questions.service';
import { SegmentedNavigationItemModel } from './components/segmented-navigation-item/segmented-navigation-item.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-segmented-navigation',
  templateUrl: './segmented-navigation.component.html',
  styleUrls: ['./segmented-navigation.component.scss'],
})
export class SegmentedNavigationComponent implements OnInit {
  @Input() items: SegmentedNavigationItemModel[];
  @Input() ulrPos = 3;

  selectedId: string;

  constructor(
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private questionsService: QuestionsService,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.setActiveItem();
  }

  public setActiveItem() {
    if (this.items != null && this.items.length > 1) {
      const tab = this.location.path()?.split('?')[0]?.split('/')[this.ulrPos];
      this.selectedId = tab ? tab : this.items[0].id;
    }
  }

  async onNavigationItemClick(tabId: string) {
    this.selectedId = tabId;
    await this.router.navigate(['./', tabId], {
      relativeTo: this.activatedRoute,
    });

    this.questionsService.selectedSortListTypeEmitter.emit();
  }
}
